var elem = document.querySelector('.main-carousel');
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'left',
  contain: true,
});

// element argument can be a selector string
//   for an individual element
var flkty2 = new Flickity( '.product-carousel', {
   selectedAttraction: 0.2,
   friction: 0.8,
    prevNextButtons: false,
    wrapAround: true,
    draggable: true
});

const sliderWrapper = document.querySelector('.product-carousel');

// sliderWrapper.addEventListener('click', () => {
//   flkty2.next();
// })